export default __webpack_public_path__ + "static/media/think_research.png.webp";